export enum TechnologyEnum {
  WiFi = 1,
  Sensors,
}
